<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list();
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">待入库</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>加工个数：{{ v.quantity }}</p>
              <p>待入库：{{ v.to_warehoused }}</p>
              <p>经办人：{{ v.operator_name }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operator_phone"> {{ v.operator_phone }}</a>
              </p>
              <template v-if="v.to_warehoused != 0">
                <!-- <template> -->
                <p class="changeType" v-if="v.type == 1" @click="v.type = 2">未找到仓位? 手动添加</p>
                <p class="changeType" v-if="v.type == 2" @click="v.type = 1">返回为级联选择</p>
                <div style="clear: both;"></div>
                <van-field
                  v-if="v.type == 1"
                  v-model="v.fieldText"
                  label="入库仓位"
                  placeholder="请选择入库仓位"
                  readonly
                  @click="
                    activeId = v.id;
                    cascaderShow = true;
                  "
                />
                <van-field
                  v-if="v.type == 2"
                  v-model="v.warehouseText_2"
                  label="子仓库"
                  placeholder="选择子仓库"
                  readonly
                  @click="
                    activeId = v.id;
                    pickerShow = true;
                  "
                />
                <van-field v-if="v.type == 2" v-model="v.warehouseText_3" label="仓位" placeholder="请输入仓位" />
                <van-field v-model="v.inventoryQuantity" type="tel" label="入库数量" placeholder="请输入入库数量" />
                <van-field v-model="v.loss" type="tel" label="损耗数量" placeholder="请输入损耗数量" />
                <!-- <div class="st-list-bottom">
                  <span class="st-opt-btn" @click="submit(v.id)">入 库</span>
                </div> -->
              </template>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">部分待入库</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>加工个数：{{ v.quantity }}</p>
              <p>待入库：{{ v.to_warehoused }}</p>
              <p>经办人：{{ v.operator_name }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operator_phone"> {{ v.operator_phone }}</a>
              </p>
              <template v-if="v.to_warehoused != 0">
                <!-- <template> -->
                <p class="changeType" v-if="v.type == 1" @click="v.type = 2">未找到仓位? 手动添加</p>
                <p class="changeType" v-if="v.type == 2" @click="v.type = 1">返回为级联选择</p>
                <div style="clear: both;"></div>
                <van-field
                  v-if="v.type == 1"
                  v-model="v.fieldText"
                  label="入库仓位"
                  placeholder="请选择入库仓位"
                  readonly
                  @click="
                    activeId = v.id;
                    cascaderShow = true;
                  "
                />
                <van-field
                  v-if="v.type == 2"
                  v-model="v.warehouseText_2"
                  label="子仓库"
                  placeholder="选择子仓库"
                  readonly
                  @click="
                    activeId = v.id;
                    pickerShow = true;
                  "
                />
                <van-field v-if="v.type == 2" v-model="v.warehouseText_3" label="仓位" placeholder="请输入仓位" />
                <van-field v-model="v.inventoryQuantity" type="tel" label="入库数量" placeholder="请输入入库数量" />
                <van-field v-model="v.loss" type="tel" label="损耗数量" placeholder="请输入损耗数量" />
                <!-- <div class="st-list-bottom">
                  <span class="st-opt-btn" @click="submit(v.id)">入 库</span>
                </div> -->
              </template>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>加工个数：{{ v.quantity }}</p>
              <p>已入库：{{ v.warehoused }}</p>
              <p>经办人：{{ v.operator_name }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operator_phone"> {{ v.operator_phone }}</a>
              </p>
            </div>
            <!-- <div class="st-list-bottom">
              <p class="st-opt-btn">查 看</p>
            </div> -->
          </div>
        </van-list>
      </div>
    </div>

    <!-- 一键入库 -->
    <div class="footer pf-btm">
      <div class="btn" @click="submit()">
        提交入库表单
      </div>
      <!-- <div class="btn" @click="orderShow = true">
        快速入库
      </div> -->
    </div>

    <!-- 选择 主仓库 子仓库 仓位 -->
    <van-popup v-model="cascaderShow" round position="bottom">
      <van-cascader title="请选择仓库信息" :options="options" @close="cascaderShow = false" @finish="onFinish" />
    </van-popup>
    <!-- 选择 子仓库  -->
    <van-popup v-model="pickerShow" round position="bottom">
      <van-picker
        title="选择子仓库"
        show-toolbar
        :columns="warehousechild"
        @confirm="onConfirm"
        @cancel="pickerShow = false"
      />
    </van-popup>

    <!-- 快速入库提交 -->
    <van-popup
      v-model="orderShow"
      closeable
      round
      position="bottom"
      :style="{ height: '90%', backgroundColor: '#f5f5f5' }"
    >
      <template>
        <van-cell-group>
          <van-field v-model="orderFrom.code" label="加工单号" placeholder="请输入加工单号" />
          <van-field
            v-if="type == 1"
            v-model="orderFrom.position_text"
            label="入库仓位"
            placeholder="请选择入库仓位"
            readonly
            @click="cascaderShow = true"
          />
          <van-field
            v-if="type == 2"
            v-model="orderFrom.warehouseText_2"
            label="子仓库"
            placeholder="选择子仓库"
            readonly
            @click="pickerShow = true"
          />
          <van-field v-if="type == 2" v-model="orderFrom.warehouseText_3" label="仓位" placeholder="请输入仓位" />
          <van-field v-model="orderFrom.stnum" type="tel" label="入库数量" placeholder="请输入入库数量" />
          <p class="changeType" v-if="type == 1" @click="type = 2">未找到仓位? 手动添加</p>
          <p class="changeType" v-if="type == 2" @click="type = 1">返回为级联选择</p>
        </van-cell-group>
      </template>
      <div class="orderSubmit" @click="orderSubmit">快速入库</div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待入库", "部分待入库", "已入库"],
      cur: 0,
      dialog_num: "",
      show: !1,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      oneinfo: {},
      activeId: "",
      cascaderShow: false,
      fieldValue: "",
      cascaderValue: "",
      options: [],
      warehousechild: [], // 子仓库选择列表
      pickerShow: false,
      type: 1, // 1 2
      orderFrom: {
        // 整单提交
        id: this.$route.params.id,
        code: "",
        stnum: "", // 数量
        position: "",
        msg: "",
        position: "",
        position_text: "",
        warehouseText_2: "",
        warehouseValue_2: "",
        warehouseText_3: "",
        warehouseValue_3: "",
      },
      orderShow: false,
      fieldText: "",
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    get_st_list() {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("processc_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("processc_activeIndex", value);
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetJiagongcangList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this.options = [result.data.list[0].position_list];
      this.warehousechild = result.data.list[0].warehousechild_list;
      let dataList = result.data.list.map((item) => {
        item.type = 1;
        item.fieldValue = "";
        item.fieldText = "";
        item.cascaderValue = "";
        item.warehouseText_2 = "";
        item.warehouseValue_2 = "";
        item.warehouseText_3 = "";
        item.warehouseValue_3 = "";
        item.inventoryQuantity = ""; // 入库数量
        item.loss = 0;
        return item;
      });

      this["stlist" + this.cur].push(...dataList);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.cascaderShow = false;
      let text = selectedOptions.map((option) => option.text).join("/");
      let value = selectedOptions.map((option) => option.value).join("/");
      value = value.substr(value.indexOf("/") + 1);

      if (this.orderShow) {
        // this.orderShow == true 表示正在进行快速入库
        let formObj = this.orderFrom;
        formObj.position = value;
        formObj.position_text = text;
        this.orderFrom = formObj;
      } else {
        let dataList = this["stlist" + this.cur].filter((item) => {
          if (item.id == this.activeId) {
            item.fieldText = text;
            item.fieldValue = value;
          }
          return item;
        });
        this["stlist" + this.cur] = dataList;
      }
    },
    // 确认子仓库的回调
    onConfirm(event) {
      let { text, value } = event;
      this.pickerShow = false;

      if (this.orderShow) {
        // this.orderShow == true 表示正在进行快速入库

        let formObj = this.orderFrom;
        formObj.warehouseValue_2 = value;
        formObj.warehouseText_2 = text;
        this.orderFrom = formObj;
        return;
      }

      this["stlist" + this.cur] = this["stlist" + this.cur].filter((item) => {
        if (item.id == this.activeId) {
          item.warehouseText_2 = text;
          item.warehouseValue_2 = value;
        }
        return item;
      });
    },
    /**
     * 过滤掉无效信息
     * @param  dataList
     */

    rulesFromHandle(dataList) {
      let result = dataList.filter((item) => {
        switch (item.type) {
          case 1:
            if (item.fieldValue != "" && item.inventoryQuantity >= 0 && item.loss >= 0) {
              return item;
            }
            break;
          case 2:
            if (
              item.warehouseValue_2 != "" &&
              item.warehouseText_3 != "" &&
              item.inventoryQuantity >= 0 &&
              item.loss >= 0
            ) {
              return item;
            }
            break;
        }
      });
      return result;
    },
    // 入库数据提交
    async submit(id) {
      let fromData;
      let data = this.rulesFromHandle(this["stlist" + this.cur]);
      if (id) {
        // 提交单挑数据
        fromData = data.filter((item) => item.id == id);
        if (!fromData.length) {
          this.$toast.fail("暂无待入库数量或仓位");
          return;
        }
      }

      if (data.length == 0) {
        return this.$toast.fail("暂无待入库数量或仓位");
      }

      let params = [];
      data.filter((item) => {
        let obj = {};
        obj.id = item.id;
        obj.stnum = item.inventoryQuantity;
        obj.loss = item.loss;
        if (item.type == 1) {
          obj.position = item.fieldValue;
          obj.msg = "";
        } else if (item.type == 2) {
          obj.position = "";
          obj.msg = item.warehouseValue_2 + "/" + item.warehouseText_3;
        }

        params.push(obj);
      });
      let result = await this.$post(this.$api.stGetJiagongcangEdit, params[0]);

      this.$toast.success("提交成功");
      this.get_st_list();
    },
    // 根据单号快速入库
    async orderSubmit() {
      let dataFrom = this.orderFrom;
      let msg = "";
      if (this.type == 1) {
        if (dataFrom.code == "" || dataFrom.position == "" || dataFrom.stnum <= 0) {
          return this.$toast("暂无待入库数量或仓位");
        }
      } else if (this.type == 2) {
        if (
          dataFrom.code == "" ||
          dataFrom.warehouseValue_2 == "" ||
          dataFrom.stnum <= 0 ||
          dataFrom.warehouseText_3 == ""
        ) {
          return this.$toast("暂无待入库数量或仓位");
        }
        msg = this.type == 1 ? "" : dataFrom.warehouseValue_2 + "/" + dataFrom.warehouseText_3;
      }

      let params = {
        // id: dataFrom.id,
        code: dataFrom.code,
        stnum: dataFrom.stnum,
        position: dataFrom.position,
        msg: msg,
      };

      console.log(params);
      let result = await this.$post(this.$api.stGetJiagongoShortcut, params);
      this.$toast.success("操作成功");
      this.orderShow = false;
      this.get_st_list();
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "加工入库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
.van-form .van-cell.van-field {
  padding: 10px 16px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */
.st-list .van-cell.van-field {
  padding: 7px 0;
}
.changeType {
  float: right;
  text-decoration-line: underline;
  color: #2a82e4;
  line-height: 1.5;
}
.van-cell.van-field {
  padding: 7px 0;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 0px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm {
  display: flex;
}
.seomain .pf-btm .btn {
  flex: 1;
  box-sizing: border-box;
  margin: 0 20px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
.seomain .pf-btm .btn:nth-child(1) {
  background-color: #2a82e4;
}
.seomain .pf-btm .btn:nth-child(2) {
  background-color: #00baad;
}
.changeType {
  margin-top: 20px;
  float: right;
  text-decoration-line: underline;
  color: #2a82e4;
  line-height: 1.5;
}
.van-cell-group {
  padding: 10px;
  padding-top: 50px;
}
.orderSubmit {
  box-sizing: border-box;
  position: absolute;
  bottom: 20px;
  margin: 0 10%;
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #00baad;
  color: #fff;
  border-radius: 11px;
  border: none;
}
</style>
